<template>
  <div v-if="isI18nLoaded" class="container-fixed offset-bottom-6 offset-top-2">
    <h1>Barring Status-Test</h1>
    <h2>Factoring</h2>
    <h3>Partners</h3>
    <VStatus type="factoring" :is-barred="false" :items="[]" />
    <VStatus type="factoring" :is-barred="true" :items="[]" />
    <VStatus type="factoring" :is-barred="false" :items="items.slice(0, 1)" />
    <VStatus type="factoring" :is-barred="true" :items="items.slice(0, 3)" />
    <h3>Voice-Factoring</h3>
    <VStatus type="voiceFactoring" :is-barred="false" :items="[]" />
    <VStatus type="voiceFactoring" :is-barred="true" :items="[]" />
    <VStatus type="voiceFactoring" :is-barred="false" :items="items.slice(0, 4)" />
    <VStatus type="voiceFactoring" :is-barred="true" :items="items.slice(0, 5)" />
    <VStatus type="voiceFactoring" :is-barred="false" :items="items" />
    <h3>Exceptions</h3>
    <VStatus type="exceptions" :is-barred="false" :items="items.slice(0, 3)" />
    <VStatus type="exceptions" :is-barred="true" :items="items" />
    <h3>Categories</h3>
    <VStatus type="category" :is-barred="true" :items="items.slice(2, 4)" />
    <VStatus type="category-exceptions" :is-barred="true" :items="items.slice(0, 3)" />
    <br />
    <h2>Reselling</h2>
    <VStatus type="reselling" :is-barred="false" :items="[]" />
    <VStatus type="reselling" :is-barred="true" :items="[]" />
    <VStatus type="reselling" :is-barred="false" :items="items.slice(1, 2)" />
    <VStatus type="reselling" :is-barred="true" :items="items.slice(2, 4)" />
  </div>
</template>

<script>
import VStatus from '@/components/Barring/Status';

export default {
  name: 'TestGrid',

  components: { VStatus },

  data() {
    return {
      items: [
        {
          id: 1,
          type: 'voiceFactoring',
          name: 'MoCoPay GmbH',
          isBarred: false,
          hasExceptions: true,
          scope: 'test',
          hasImage: false,
        },
        {
          id: 2,
          type: 'factoring',
          name: 'Google',
          isBarred: true,
          hasExceptions: false,
          scope: 'test',
          hasImage: false,
        },
        {
          id: 1,
          type: 'voiceFactoring',
          name: 'King.com',
          isBarred: false,
          hasExceptions: true,
          scope: 'test',
          hasImage: false,
        },
        {
          id: 1,
          type: 'globalShortCode',
          name: 'iTunes (Apple) Sarl',
          isBarred: false,
          hasExceptions: false,
          scope: 'test',
          hasImage: false,
        },
        {
          id: 1,
          type: 'factoring',
          name: 'Movie Star Planet',
          isBarred: true,
          hasExceptions: true,
        },
        {
          id: 1,
          type: 'shortCode',
          name: 'Stadtwerke Bonn Verkehrs GmbH',
          isBarred: false,
          hasExceptions: false,
          scope: 'test',
          hasImage: false,
        },
        {
          id: 1,
          type: 'shortCode',
          name: '118',
          isBarred: false,
          hasExceptions: false,
        },
        {
          id: 1,
          type: 'shortCode',
          name: '119',
          isBarred: false,
          hasExceptions: false,
        },
        {
          id: 1,
          type: 'factoring',
          name: 'This is a very long text. Lorem ipsum dolor. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.',
          isBarred: false,
          hasExceptions: true,
          scope: 'test',
          hasImage: false,
        },
        {
          id: 1,
          type: 'voiceFactoring',
          name: 'BOKU Network Services AG',
          isBarred: false,
          hasExceptions: false,
        },
      ],
    };
  },

  computed: {
    isI18nLoaded() {
      return !!this.$i18n.messages.de.barring;
    },
  },
};
</script>
